import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { CatProduit } from '../../model/catproduit';
import { Categorie } from '../../model/categorie';



@Injectable()
export class CategoryService {

  categories: Categorie[];

  iSconnecting: boolean = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

  getAllCategoryProvider(type: string){

    return this.http.get<Categorie[]>(this.apiEndpoints.URL_GET_CATEGORY(type), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }

  addCategorieProvider(cat: Categorie){

    let idparent = null;

    if(cat.parent !== undefined && cat.parent !== null)
    idparent = cat.parent.id;
  
    const body =  {
      nom: cat.nom,
      parent:idparent,
      description: cat.description,
      typeContent: cat.type_content,
      photoSelected:cat.photo,
    };

    var donnees = JSON.stringify(body);

    return this.http.post(this.apiEndpoints.GET_URL_POST_CATEGORY, donnees, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  
  }

  updateCategoryProvider(cat: Categorie){

    let idparent = null;

    if(cat.parent !== undefined && cat.parent !== null)
    idparent = cat.parent.id;
   
    const body=  {
      nom: cat.nom,
      parent:idparent,
      description: cat.description,
      typeContent: cat.type_content,
      photoSelected:cat.photo,          
     };
    
     var donnees = JSON.stringify(body);
    
   return this.http.patch(this.apiEndpoints.GET_URL_PUT_CATEGORY(cat.id), donnees, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  }


  deleteCategoryProvider(id){

    return this.http.delete(this.apiEndpoints.GET_URL_DELETE_CATEGORY(id), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }


  getOneCategoryProvider(id){

    return this.http.get(this.apiEndpoints.URL_GET_CATEGORYBYID(id), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }







  /* getCats() {
    this.iSconnecting = true;
    return new Promise<CatProduit[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_CATPRODUITS,
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: CatProduit[]) => {
            const catproduits = plainToClass(CatProduit, data);
            this.catproduits = catproduits;
            resolve(catproduits);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  } */

  /* getCat(id: number)  {

    if (this.catproduits !== undefined) {

          return new Promise<CatProduit>( resolve => {

            for ( let i = 0; i < this.catproduits.length; i++) {

              if (this.catproduits[i].id === id) {
                resolve( this.catproduits[i]);
              }

            }

          });

    } else {

      return new Promise<CatProduit>( resolve => {
          this.getCats().then( cats => {
            for ( let i = 0; i < this.catproduits.length; i++) {

                if (this.catproduits[i].id === id) {
                  resolve( this.catproduits[i]);
                }

            }

          });
      });

    }


  } */

  /* saveCatProduit(cat: CatProduit) {
    this.iSconnecting = true;


    const pat = {

      nom: cat.nom,
      description: cat.description,
      parent: (cat.parent !== null && cat.parent !== undefined) ? cat.parent.id : null,

    };


    if (cat.id !== 0) {

      this.iSconnecting = true;

      return new Promise<CatProduit>(resolve => {
        this.http.put(this.apiEndpoints.GET_URL_PUT_CATPRODUIT(cat.id), pat,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: CatProduit) => {

            this.getCats().then( cats => {
              resolve(data);
              this.iSconnecting = false;
            });


            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }else {

      return new Promise<CatProduit>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_POST_CATPRODUIT, pat,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: CatProduit) => {

              this.getCats().then( cats => {
                resolve(data);
                this.iSconnecting = false;
              });

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }



  } */


  /* deleteCatProduit(id: number) {
    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_CATPRODUIT(id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            this.getCats().then( cats => {
              resolve(data);
              this.iSconnecting = false;
            });

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });


  } */


}
